module.exports = __webpack_public_path__ + "img/process-img-2.71705617.png";